"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentScanStatusEnumToJSON = exports.DocumentScanStatusEnumFromJSONTyped = exports.DocumentScanStatusEnumFromJSON = exports.DocumentScanStatusEnum = void 0;
/**
 * Scan status for document validation on pod
 * @export
 * @enum {string}
 */
var DocumentScanStatusEnum;
(function (DocumentScanStatusEnum) {
    DocumentScanStatusEnum["CHECKCOMPLETE"] = "CHECK COMPLETE";
    DocumentScanStatusEnum["DOCUMENTMISMATCH"] = "DOCUMENT MISMATCH";
    DocumentScanStatusEnum["EXPIRED"] = "EXPIRED";
    DocumentScanStatusEnum["INREVIEW"] = "IN REVIEW";
    DocumentScanStatusEnum["NOTSCANNED"] = "NOT SCANNED";
    DocumentScanStatusEnum["NOTSUPPORTED"] = "NOT SUPPORTED";
    DocumentScanStatusEnum["OVERRIDDEN"] = "OVERRIDDEN";
    DocumentScanStatusEnum["PREVIOUSLYUPLOADED"] = "PREVIOUSLY UPLOADED";
    DocumentScanStatusEnum["TRYSCANAGAIN"] = "TRY SCAN AGAIN";
    DocumentScanStatusEnum["UNKNOWNRETRYSCAN"] = "UNKNOWN, RETRY SCAN";
    DocumentScanStatusEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(DocumentScanStatusEnum = exports.DocumentScanStatusEnum || (exports.DocumentScanStatusEnum = {}));
function DocumentScanStatusEnumFromJSON(json) {
    return DocumentScanStatusEnumFromJSONTyped(json, false);
}
exports.DocumentScanStatusEnumFromJSON = DocumentScanStatusEnumFromJSON;
function DocumentScanStatusEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DocumentScanStatusEnumFromJSONTyped = DocumentScanStatusEnumFromJSONTyped;
function DocumentScanStatusEnumToJSON(value) {
    return value;
}
exports.DocumentScanStatusEnumToJSON = DocumentScanStatusEnumToJSON;
//# sourceMappingURL=DocumentScanStatusEnum.js.map